module.exports = __webpack_public_path__ + "static/media/zoom2u.44613828.svg";